import { useEffect, useMemo } from 'react';

export const useMobilePerformanceOptimization = () => {
  const isMobile = useMemo(() => 
    window.innerWidth <= 768 && ('ontouchstart' in window || navigator.maxTouchPoints > 0), 
    []
  );
  
  useEffect(() => {
    if (isMobile) {
      // Reduce animation duration for mobile
      document.documentElement.style.setProperty('--animation-duration', '0.2s');
      
      // Add mobile-specific optimizations
      const style = document.createElement('style');
      style.textContent = `
        /* Mobile performance optimizations */
        * {
          transform: translateZ(0);
        }
        
        /* Reduce blur effects on mobile */
        .backdrop-blur-md {
          backdrop-filter: blur(4px) !important;
        }
        
        /* Optimize images for mobile */
        img {
          image-rendering: optimizeSpeed;
        }
        
        /* Reduce box shadows on mobile */
        .shadow-sm {
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
        }
      `;
      document.head.appendChild(style);
      
      return () => {
        document.head.removeChild(style);
      };
    }
  }, [isMobile]);

  return {
    isMobile,
    // Reduced limits for mobile
    postsLimit: isMobile ? 5 : 10,
    castsLimit: isMobile ? 3 : 7,
    // Disable heavy features on mobile
    enableVideoAutoplay: !isMobile,
    enableHeavyAnimations: !isMobile,
  };
};